export function filterListByText(list, searchText, key = null) {
  if (!searchText) return list;

  return list.filter((item) => {
    const value = key ? item[key] : item;
    return value?.toString().toLowerCase().includes(searchText.toLowerCase());
  });
}
